import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
export const LauncherBarStack = styled(Stack)(({ theme }) => ({
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing(2, 4),
    borderTopLeftRadius: theme.spacing(2),
    borderTopRightRadius: theme.spacing(2),
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    backgroundColor: 'rgb(242, 242, 242)',
    gap: theme.spacing(2),
    cursor: 'pointer',
}));
export const LogoContainerBox = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 171, 186, 1)', // connect blue
    width: 32,
    height: 32,
    borderRadius: 16,
    // we need this to position the status color relative to this
    // container
    position: 'relative',
});
export const StatusHintBox = styled(Box)({
    position: 'absolute',
    // anchor to the bottom right, relative to parent,
    // offset by border width
    right: -2,
    bottom: -2,
    height: 8,
    width: 8,
    borderRadius: 8,
    borderWidth: 2,
    borderColor: 'white',
    borderStyle: 'solid',
    boxSizing: 'content-box',
});
export const Title = styled(Typography)({
    flexGrow: 1,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: 0,
});
//# sourceMappingURL=data:application/json;base64,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